module.exports = __webpack_public_path__ + "images/frontpage_sizes@3x.png?44ed6bfd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_sizes@3x.png
// module id = 662
// module chunks = 7